import React, { createContext, useContext, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { useGetCodeSet } from '../../../APIs/Hooks/CodeSetHooks'
import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { useReaderValidate } from '../../../APIs/Hooks/ReaderHooks'
import { barcodesTS, ReaderContextType } from './Interfaces'

const ReaderContext = createContext<ReaderContextType>({} as ReaderContextType)
export const useReaderContext = () => useContext(ReaderContext)

function ReaderModule({ children }: { children: any }) {
  const [barcodes, setBarcodes] = useState<barcodesTS>({})
  const [openClear, setOpenClear] = useState(false)
  const [openLoad, setOpenLoad] = useState(false)
  const [sourceBatch, setSourceBatch] = useState(false)
  const [selectedFunc, setSelectedFunc] = useState(null)
  const [confirmClear, setConfirmClear] = useState(false)

  const readerFunctionQuery = useGetCodeSet('ReaderFunctionID')

  const [containerSelectionModel, setContainerSelectionModel] =
    useState<GridRowSelectionModel>([])
  const [vesselSelectionModel, setVesselSelectionModel] =
    useState<GridRowSelectionModel>([])

  // NOTE: Cannot cache results as rack barcode is separate but sequential
  const mutateBarcodes = useReaderValidate(
    sourceBatch,
    setContainerSelectionModel,
    setVesselSelectionModel,
    setOpenClear,
    setConfirmClear,
    setOpenLoad,
  )

  const { data: barcodesData, mutate: validateBarcodes } = mutateBarcodes

  useEffect(() => {
    if (Object.keys(barcodes).length > (barcodesData?.total ?? 0)) {
      validateBarcodes(
        Object.entries(barcodes)
          .sort(([a_key, a_value], [b_key, b_value]) =>
            a_value.localeCompare(b_value),
          )
          .map(([key, value]) => key),
      )
    }
  }, [barcodes, barcodesData, validateBarcodes])

  return (
    <ReaderContext.Provider
      value={{
        readerFunctionQuery,
        openClear,
        setOpenClear,
        setConfirmClear,
        confirmClear,
        setBarcodes,
        barcodes,
        containerSelectionModel,
        vesselSelectionModel,
        mutateBarcodes,
        setContainerSelectionModel,
        setVesselSelectionModel,
        selectedFunc,
        setSelectedFunc,
        openLoad,
        setOpenLoad,
        setSourceBatch,
      }}
    >
      <Box
        sx={{
          width: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {children}
      </Box>
    </ReaderContext.Provider>
  )
}

export default ReaderModule
